var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["filter"].concat(_vm.appClasses()) },
    [
      _vm.heading
        ? _c("h4", {
            class: ["filter__heading"],
            domProps: { innerHTML: _vm._s(_vm.heading) }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "inner-container" }, [
        _c(
          "form",
          {
            attrs: {
              action: _vm.formAction,
              name: "searchfilter",
              method: _vm.formMethod
            },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.$emit("submit", $event)
              }
            }
          },
          [
            this.displayKeywords
              ? _c("div", { staticClass: "input-container" }, [
                  _c("label", { attrs: { for: "filter-keywords" } }, [
                    _vm._v("Search")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.keywords,
                        expression: "keywords"
                      }
                    ],
                    attrs: {
                      id: "filter-keywords",
                      type: "text",
                      placeholder: "search keywords"
                    },
                    domProps: { value: _vm.keywords },
                    on: {
                      keyup: function($event) {
                        return _vm.$emit("update:keywords", $event.target.value)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.keywords = $event.target.value
                      }
                    }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._t("precategories"),
            _vm._v(" "),
            _vm._t("categories", [
              _vm.categories.length > 1
                ? _c("div", { staticClass: "input-container" }, [
                    _c("label", { attrs: { for: "filter-category" } }, [
                      _vm._v("Category")
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.category,
                            expression: "category"
                          }
                        ],
                        attrs: { id: "filter-category" },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.category = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function($event) {
                              return _vm.$emit(
                                "update:category",
                                $event.target.value
                              )
                            }
                          ]
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("Category")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.categories, function(category, index) {
                          return _c("option", {
                            key: index,
                            domProps: {
                              value: category.value,
                              innerHTML: _vm._s(category.label)
                            }
                          })
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm._t("postcategories"),
            _vm._v(" "),
            this.displayDateRange
              ? _c(
                  "div",
                  { staticClass: "input-container date-range-picker" },
                  [
                    _c("label", { attrs: { for: "filter-date-picker" } }, [
                      _vm._v("Date Range")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "flatpickr flatpickr-input active",
                      attrs: {
                        id: "filter-date-picker",
                        type: "text",
                        placeholder: "Select Date..."
                      }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.displayResetBtn
              ? _c("div", { staticClass: "input-container reset" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.resetForm()
                        }
                      }
                    },
                    [_vm._v("Reset")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.displaySearchBtn
              ? _c("div", { staticClass: "input-container submit" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      attrs: { type: "submit" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("click:search", $event)
                        }
                      }
                    },
                    [_vm._v("Search")]
                  )
                ])
              : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm._t("footer")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib?{}!./scripts/vue/SearchFilter.vue?vue&type=template&id=e410dc18&
// module id = 23
// module chunks = 0 1 2 3 4 5